<template>
  <channel-metrics-chart
    class="channel-metric-ct"
    v-if="chartData"
    :chart-type="chartType"
    :key="key"
    :title="$t(`CampaignAnalytics_Channel_${channel}`)"
    :icon="`dashboard_${channel}`"
    :chart-data="chartData || {}"
    :height="getChannelHeight((chartData.datasets || []).length)"
    :align-ticks-with-second-axis="true"
  />
</template>

<script>
import ChannelMetricsChart from '@/common/components/ChannelMetricsChart.vue'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import AnalyticsMixin from '@/modules/campaign-manage/mixins/AnalyticsMixin'

export default {
  name: 'ChannelSummary',
  components: { ChannelMetricsChart },
  mixins: [AnalyticsMixin],
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      key: null,
      reportData: {}
    }
  },
  props: {
    channel: {
      type: String,
      required: true
    },

    analyticsDateRange: {
      type: Object,
      required: true
    },

    model: {
      type: Object,
      required: true
    }
  },
  methods: {
    fetchData() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `campaigns/${this.$route.query.id}/analytics/engagement-chart-data`,
          params: {
            startDate: this.analyticsDateRange.date_from,
            endDate: this.analyticsDateRange.date_to,
            channels: [this.channel],
            all: true
          }
        })
      )
        .then(({ data }) => {
          this.reportData = data.data
          this.$nextTick(() => {
            this.key = new Date().getTime()
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  watch: {
    analyticsDateRange: {
      handler: function() {
        this.fetchData()
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/ChannelSummary.vue